import React, { Component } from 'react';

//Custom Components
import TopAppBar from '../../../components/SiteSpecific/TopAppBar';
import { Profile } from '../Profile/Profile';
import { ModalDialog } from '../Utilities/ModalDialog'
import { BottomNav } from '../Utilities/BottomNav';
import { Welcome } from '../../../components/SiteSpecific/Welcome';
    //import { Affiliations } from '../Groups/Affiliations'
    //import { Activity } from '../Groups/Activity'
import { ChatDrawer } from '../Messenger/ChatDrawer';
import { Notifications } from '../Notifications/Notifications'
import { Invitations } from '../Invitations/Invitations'
import { Account } from '../Account/Account'

//Database Services
import { getNotifications, updateNotification } from '../../DataServices/NotificationService'
import { getInvitations, confirmInvitation, declineInvitation, removeInvitation } from '../../DataServices/OrganizationService'

export class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showMenu: false,
            showPhotoUploader: false,
            showSearchResults: false,
            showProfileManager: false,
            showAffiliations: false,
            showNotifications: false,
            showInvitations: false,
            showAccount: false,
            showChat: false,
            notifications: [],
            invitations: [],
            fetchNewPostsInterval: 30000,
            autoFetchNew: true,
            navIndex: 0,
            lastNavIndex: 0,
            width: 0,
            height: 0,

            // ✅ Mobile bottom nav overlay
            showBottomNavMobile: false,
        };

        this._bottomNavHideTimer = null;
    }

    // ---------- helpers ----------
    isMobile = () => (this.state.width || window.innerWidth) <= 600;

    clearBottomNavTimers = () => {
        if (this._bottomNavHideTimer) {
            clearTimeout(this._bottomNavHideTimer);
            this._bottomNavHideTimer = null;
        }
    };

    showBottomNav = () => {
        if (!this.isMobile()) return;
        this.clearBottomNavTimers();
        if (!this.state.showBottomNavMobile) {
            this.setState({ showBottomNavMobile: true });
        }
    };

    // hide after inactivity (4–5 seconds)
    scheduleBottomNavHide = (ms = 4500) => {
        if (!this.isMobile()) return;
        this.clearBottomNavTimers();
        this._bottomNavHideTimer = setTimeout(() => {
            this.setState({ showBottomNavMobile: false });
        }, ms);
    };

    // keep it visible while the user is engaging
    keepBottomNavAlive = (ms = 4500) => {
        if (!this.isMobile()) return;
        this.showBottomNav();
        this.scheduleBottomNavHide(ms);
    };

    // ---------- lifecycle ----------
    componentDidMount() {
        if (this.props.user && this.props.user.accessToken && !this.props.user.hideWelcome) {
            this.setState({ showWelcome: true });
        }

        this.getInvitations();
        this.getNotifications();

        if (this.state.autoFetchNew) {
            setTimeout(
                this.interval = setInterval(() => {
                    this.getNewInvitations();
                    this.getNewNotifications();
                }, this.state.fetchNewPostsInterval),
                60000
            );
        }

        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);
        window.removeEventListener('resize', this.updateWindowDimensions);
        this.clearBottomNavTimers();
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    // ---------- data ----------
    getNotifications = async () => {
        const data = await getNotifications(true, this.props.appIdentifier);
        const notifications = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].referencedUser) notifications.push(data[i]);
            }
            this.setState({ notifications, loading: false });
        }
    }

    getNewNotifications = async () => {
        const data = await getNotifications(true, this.props.appIdentifier);
        const notifications = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].referencedUser) notifications.push(data[i]);
            }

            if (notifications.length === this.state.notifications.length) {
                if (notifications.length === 0) return;
                if (
                    notifications[0].id === this.state.notifications[0].id &&
                    notifications[notifications.length - 1].id === this.state.notifications[this.state.notifications.length - 1].id
                ) return;
            }

            this.setState({ notifications, loading: false });
        }
    }

    getInvitations = async () => {
        const data = await getInvitations();
        const invitations = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].fromUser) invitations.push(data[i]);
            }
            this.setState({ invitations });
        }
    }

    getNewInvitations = async () => {
        const data = await getInvitations();
        const invitations = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].fromUser) invitations.push(data[i]);
            }

            if (invitations.length === this.state.invitations.length) {
                if (invitations.length === 0) return;
                if (
                    invitations[0].id === this.state.invitations[0].id &&
                    invitations[invitations.length - 1].id === this.state.invitations[this.state.invitations.length - 1].id
                ) return;
            }

            this.setState({ invitations });
        }
    }

    // ---------- actions ----------
    handleCancel = async (item, index) => {
        this.setState(state => {
            const notifications = state.notifications.filter((_, j) => index !== j);
            return { notifications };
        });

        let user = this.props.user;
        user.notificationCount--;
        this.props.setUserInfo(user);

        await updateNotification(item.id, 3);
    }

    handleAccept = async (item, index) => {
        this.setState(state => {
            const notifications = state.notifications.filter((_, j) => index !== j);
            return { notifications };
        });

        let user = this.props.user;
        user.notificationCount--;
        this.props.setUserInfo(user);

        await updateNotification(item.id, 3);
    }

    handleAcceptInvitation = async (item, index) => {
        const invitations = [...this.state.invitations];
        invitations.splice(index, 1);
        this.setState({ invitations });
        await confirmInvitation(item.id);
    }

    handleDeclineInvitation = async (item, index) => {
        const invitations = [...this.state.invitations];
        invitations.splice(index, 1);
        this.setState({ invitations });
        await declineInvitation(item.id);
    }

    handleDismissInvitation = async (item, index) => {
        const invitations = [...this.state.invitations];
        invitations.splice(index, 1);
        this.setState({ invitations });
        await removeInvitation(item.id);
    }

    handleSearch = async (term) => {
        if (term && term.length > 0) {
            this.props.setSearchTerm(term);
            this.handleNavIndex(0);
        }
    }

    handleUpdateProfile = (b64) => {
        this.setState({ showPhotoUploader: false });
        let user = this.props.user;
        user.avatar = b64;
        this.props.setUserInfo(user);
    }

    handleNavIndex = (value) => {
        this.setState({ navIndex: value });

        switch (value) {
            case 0:
                this.props.setTopic("posts");
                this.setState({ lastNavIndex: value, showChat: false, showNotifications: false, showProfileManager: false });
                break;
            case 1:
                this.props.setTopic("content");
                this.setState({ lastNavIndex: value, showChat: false, showNotifications: false, showProfileManager: false });
                break;
            case 2:
                this.setState({ showChat: true, showNotifications: false, showProfileManager: false });
                break;
            case 3:
                this.setState({ showChat: false, showNotifications: true, showProfileManager: false });
                break;
            case 4:
                this.setState({ showChat: false, showNotifications: false, showProfileManager: true });
                break;
            default:
        }

        // ✅ if user uses nav on mobile, keep it visible briefly
        if (this.isMobile()) this.keepBottomNavAlive(4500);
    }

    handleToggleChat = () => {
        this.setState({ showChat: !this.state.showChat })
        if (this.state.navIndex === 2) {
            this.setState({ navIndex: this.state.lastNavIndex });
        }
    }

    handleCloseProfileManager = () => {
        this.setState({ showProfileManager: false });
        if (this.state.navIndex === 4) {
            this.setState({ navIndex: this.state.lastNavIndex });
        }
    }

    handleCloseNotifications = () => {
        this.setState({ showNotifications: false });
        if (this.state.navIndex === 3) {
            this.setState({ navIndex: this.state.lastNavIndex });
        }
    }

    handleSetTopic = (topic) => {
        if (topic === "posts") this.handleNavIndex(0);
        if (topic === "content") this.handleNavIndex(1);
    }

    // ---------- renders ----------
    chat = () => {
        if (!this.state.showChat) return null;
        return (
            <ChatDrawer
                show={this.state.showChat}
                dark={this.props.dark}
                setToken={this.props.setToken}
                width={this.state.width}
                toggleOpen={this.handleToggleChat}
                user={this.props.user}
                height={this.state.height}
            />
        );
    }

    welcome = () => (
        <Welcome
            show={this.state.showWelcome}
            hide={() => this.setState({ showWelcome: false })}
            handleUpdateProfile={this.handleUpdateProfile}
            dark={this.props.dark}
            user={this.props.user}
            setUserInfo={this.props.setUserInfo}
            setDark={this.props.setDark}
            appIdentifier={this.props.appIdentifier}
        />
    )

    profileManager = () => (
        <ModalDialog
            dark={this.state.width <= 600 ? true : this.props.dark}
            show={this.state.showProfileManager}
            handleClose={this.handleCloseProfileManager}
            closeLabel="Close"
            fullWidth={true}
            title="Profile Manager"
            maxWidth="xl"
            noPad={true}
            fullScreen={this.state.width <= 600}
            solid={this.state.width <= 600}
            hideScroll={true}
            disableButtons
            fullHeight
        >
            <Profile
                {...this.props}
                user={this.props.user}
                setUserInfo={this.props.setUserInfo}
                fullScreen={this.state.width <= 600}
            />
        </ModalDialog>
    )

    //affiliations = () => (
    //    <ModalDialog
    //        dark={true}
    //        show={this.state.showAffiliations}
    //        handleClose={() => this.setState({ showAffiliations: false })}
    //        closeLabel="Close"
    //        fullWidth={true}
    //        fullScreen={this.state.width <= 600}
    //        solid
    //        title="Affiliations"
    //        maxWidth="md"
    //        noPad={true}
    //        hideScroll={true}
    //        disableButtons
    //        fullHeight
    //        noBorder
    //    >
    //        <Affiliations
    //            appIdentifier={this.props.appIdentifier}
    //            dark={this.props.dark}
    //            user={this.props.user}
    //        />
    //    </ModalDialog>
    //)

    //activities = () => (
    //    <ModalDialog
    //        dark={this.state.width <= 600 ? true : this.props.dark}
    //        show={this.state.showActivity}
    //        handleClose={() => this.setState({ showActivity: false })}
    //        closeLabel="Close"
    //        fullWidth={true}
    //        fullScreen={this.state.width <= 600}
    //        solid
    //        title="My Activity and Connections"
    //        maxWidth="md"
    //        noPad={true}
    //        hideScroll={true}
    //        disableButtons
    //        fullHeight
    //        noBorder
    //    >
    //        <Activity
    //            appIdentifier={this.props.appIdentifier}
    //            dark={this.props.dark}
    //            user={this.props.user}
    //        />
    //    </ModalDialog>
    //)

    notifications = () => (
        <Notifications
            show={this.state.showNotifications}
            handleClose={this.handleCloseNotifications}
            dark={this.props.dark}
            setUserInfo={this.props.setUserInfo}
            user={this.props.user}
            handleCancel={this.handleCancel}
            handleAccept={this.handleAccept}
            notifications={this.state.notifications}
            setSelectedPost={this.props.setSelectedPost}
            fullScreen={this.state.width <= 600}
        />
    )

    invitations = () => (
        <Invitations
            show={this.state.showInvitations}
            handleClose={() => this.setState({ showInvitations: false })}
            dark={this.props.dark}
            user={this.props.user}
            handleCancel={this.handleDeclineInvitation}
            handleAccept={this.handleAcceptInvitation}
            handleDecline={this.handleDeclineInvitation}
            invitations={this.state.invitations}
        />
    )

    account = () => (
        <Account
            show={this.state.showAccount}
            handleClose={() => this.setState({ showAccount: false })}
            dark={this.props.dark}
            user={this.props.user}
            setToken={this.props.setToken}
        />
    )

    // NOTE: you spelled this "bottonNav" originally; left it as-is
    bottonNav = (overlay = false) => (
        <BottomNav
            overlay={overlay}
            dark={this.props.dark}
            index={this.state.navIndex}
            setIndex={this.handleNavIndex}
            notificationCount={this.state.notifications.length ?? 0}
            hasNewMessages={this.props.user.hasNewMessages}
            // ✅ hint prop (won't break if BottomNav ignores it)
            overlay={this.isMobile()}
        />
    )

    // ✅ Mobile overlay: IMPORTANT CHANGE:
    // - On mobile, DO NOT render BottomNav at all unless visible === true
    //   (this fixes "always visible" when BottomNav uses position: fixed internally)
    renderBottomNav = () => {
        if (!this.isMobile()) return this.bottonNav(false);

        const visible = this.state.showBottomNavMobile;

        return (
            <>
                {/* hotzone */}
                <div
                    style={{
                        position: "fixed",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        height: 70,
                        zIndex: 999998,
                        background: "transparent",
                        touchAction: "manipulation",
                    }}
                    onPointerDown={() => this.showBottomNav()}
                    onPointerUp={() => this.scheduleBottomNavHide(4500)}
                    onPointerCancel={() => this.scheduleBottomNavHide(4500)}
                    onTouchStart={() => this.showBottomNav()}
                    onTouchEnd={() => this.scheduleBottomNavHide(4500)}
                />

                {/* slide overlay */}
                <div
                    style={{
                        position: "fixed",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 999999,
                        transform: visible ? "translateY(0)" : "translateY(110%)",
                        transition: "transform 220ms ease",
                        pointerEvents: visible ? "auto" : "none",
                    }}
                    onPointerDown={() => this.keepBottomNavAlive(4500)}
                    onPointerMove={() => this.keepBottomNavAlive(4500)}
                    onTouchStart={() => this.keepBottomNavAlive(4500)}
                    onMouseEnter={() => this.keepBottomNavAlive(4500)}
                    onPointerUp={() => this.scheduleBottomNavHide(4500)}
                    onTouchEnd={() => this.scheduleBottomNavHide(4500)}
                >
                    {this.bottonNav(true)}
                </div>
            </>
        );
    };


    content = () => {
        return (
            <>
                <TopAppBar
                    user={this.props.user}
                    setToken={this.props.setToken}
                    dark={this.props.dark}
                    setDark={this.props.setDark}
                    getPhoto={this.props.getPhoto}
                    setUserInfo={this.props.setUserInfo}
                    searchCallback={this.handleSearch}
                    handleProfileOpen={() => this.setState({ showProfileManager: !this.state.showProfileManager })}
                    handleAffiliationsOpen={() => this.setState({ showAffiliations: !this.state.showAffiliations })}
                    handleActivityOpen={() => this.setState({ showActivity: !this.state.showActivity })}
                    handleNotificationsOpen={() => this.setState({ showNotifications: !this.state.showNotifications })}
                    handleInvitationsOpen={() => this.setState({ showInvitations: !this.state.showInvitations })}
                    handleAccountOpen={() => this.setState({ showAccount: !this.state.showAccount })}
                    handleChatOpen={() => this.setState({ showChat: !this.state.showChat })}
                    notificationCount={this.state.notifications.length ?? 0}
                    invitationCount={this.state.invitations.length ?? 0}
                    searchTerm={this.props.searchTerm ?? ""}
                    authenticated={this.props.authenticated}
                    newRegistration={this.props.newRegistration}
                    setNewRegistration={this.props.setNewRegistration}
                    setAuthenticated={this.props.setAuthenticated}
                    setTopic={this.handleSetTopic}
                    navIndex={this.state.navIndex}
                    appOptions={this.props.appOptions}
                />

                {this.props.children}

                {/* ✅ Bottom nav behavior you described */}
                {this.renderBottomNav()}

                {this.state.showWelcome && this.welcome()}
                {this.state.showChat && this.chat()}
                {this.state.showProfileManager && this.profileManager()}
                //{this.state.showAffiliations && this.affiliations()}
                //{this.state.showActivity && this.activities()}
                {this.state.showNotifications && this.notifications()}
                {this.state.showInvitations && this.invitations()}
                {this.state.showAccount && this.account()}
            </>
        );
    }

    render() {
        return this.content();
    }
}



//import React, { Component } from 'react';

////Custom Components
//import TopAppBar from '../../../components/SiteSpecific/TopAppBar';
//import { Profile } from '../Profile/Profile';
//import { ModalDialog } from '../Utilities/ModalDialog'
//import { BottomNav } from '../Utilities/BottomNav';
//import { Welcome } from '../../../components/SiteSpecific/Welcome';
//import { Affiliations } from '../Groups/Affiliations'
//import { Activity } from '../Groups/Activity'
//import { ChatDrawer } from '../Messenger/ChatDrawer';
//import { Notifications } from '../Notifications/Notifications'
//import { Invitations } from '../Invitations/Invitations'
//import { Account } from '../Account/Account'

////Database Services
//import { getNotifications, updateNotification } from '../../DataServices/NotificationService'
//import { getInvitations, confirmInvitation, declineInvitation, removeInvitation } from '../../DataServices/OrganizationService'

//export class Layout extends Component {
//    constructor(props) {
//        super(props);
//        this.state = {
//            showMenu: false,
//            showPhotoUploader: false,
//            showSearchResults: false,
//            showProfileManager: false,
//            showAffiliations: false,
//            showNotifications: false,
//            showInvitations: false,
//            showAccount: false,
//            showChat: false,
//            notifications: [],
//            invitations: [],
//            fetchNewPostsInterval: 30000,
//            autoFetchNew: true,
//            navIndex: 0,
//            lastNavIndex: 0,
//            width: 0,
//            height: 0,

//            // ✅ Mobile bottom nav overlay
//            showBottomNavMobile: false,
//        };

//        // timers
//        this._bottomNavHideTimer = null;
//    }

//    // ---------- helpers ----------
//    isMobile = () => (this.state.width || window.innerWidth) <= 600;

//    clearBottomNavTimers = () => {
//        if (this._bottomNavHideTimer) {
//            clearTimeout(this._bottomNavHideTimer);
//            this._bottomNavHideTimer = null;
//        }
//    };

//    showBottomNav = () => {
//        if (!this.isMobile()) return;
//        this.clearBottomNavTimers();
//        if (!this.state.showBottomNavMobile) {
//            this.setState({ showBottomNavMobile: true });
//        }
//    };

//    // hide after inactivity (4–5 seconds)
//    scheduleBottomNavHide = (ms = 4500) => {
//        if (!this.isMobile()) return;
//        this.clearBottomNavTimers();
//        this._bottomNavHideTimer = setTimeout(() => {
//            this.setState({ showBottomNavMobile: false });
//        }, ms);
//    };

//    // keep it visible while the user is engaging
//    keepBottomNavAlive = (ms = 4500) => {
//        if (!this.isMobile()) return;
//        this.showBottomNav();
//        this.scheduleBottomNavHide(ms);
//    };

//    // ---------- lifecycle ----------
//    componentDidMount() {
//        if (this.props.user && this.props.user.accessToken && !this.props.user.hideWelcome) {
//            this.setState({ showWelcome: true });
//        }

//        this.getInvitations();
//        this.getNotifications();

//        if (this.state.autoFetchNew) {
//            setTimeout(
//                this.interval = setInterval(() => {
//                    this.getNewInvitations();
//                    this.getNewNotifications();
//                }, this.state.fetchNewPostsInterval),
//                60000
//            );
//        }

//        this.updateWindowDimensions();
//        window.addEventListener('resize', this.updateWindowDimensions);
//    }

//    componentWillUnmount() {
//        if (this.interval) clearInterval(this.interval);
//        window.removeEventListener('resize', this.updateWindowDimensions);
//        this.clearBottomNavTimers();
//    }

//    updateWindowDimensions = () => {
//        this.setState({ width: window.innerWidth, height: window.innerHeight });
//    }

//    // ---------- data ----------
//    getNotifications = async () => {
//        const data = await getNotifications(true, this.props.appIdentifier);
//        const notifications = [];
//        if (data) {
//            for (let i = 0; i < data.length; i++) {
//                if (data[i].referencedUser) notifications.push(data[i]);
//            }
//            this.setState({ notifications, loading: false });
//        }
//    }

//    getNewNotifications = async () => {
//        const data = await getNotifications(true, this.props.appIdentifier);
//        const notifications = [];
//        if (data) {
//            for (let i = 0; i < data.length; i++) {
//                if (data[i].referencedUser) notifications.push(data[i]);
//            }

//            if (notifications.length === this.state.notifications.length) {
//                if (notifications.length === 0) return;
//                if (
//                    notifications[0].id === this.state.notifications[0].id &&
//                    notifications[notifications.length - 1].id === this.state.notifications[this.state.notifications.length - 1].id
//                ) return;
//            }

//            this.setState({ notifications, loading: false });
//        }
//    }

//    getInvitations = async () => {
//        const data = await getInvitations();
//        const invitations = [];
//        if (data) {
//            for (let i = 0; i < data.length; i++) {
//                if (data[i].fromUser) invitations.push(data[i]);
//            }
//            this.setState({ invitations });
//        }
//    }

//    getNewInvitations = async () => {
//        const data = await getInvitations();
//        const invitations = [];
//        if (data) {
//            for (let i = 0; i < data.length; i++) {
//                if (data[i].fromUser) invitations.push(data[i]);
//            }

//            if (invitations.length === this.state.invitations.length) {
//                if (invitations.length === 0) return;
//                if (
//                    invitations[0].id === this.state.invitations[0].id &&
//                    invitations[invitations.length - 1].id === this.state.invitations[this.state.invitations.length - 1].id
//                ) return;
//            }

//            this.setState({ invitations });
//        }
//    }

//    // ---------- actions ----------
//    handleCancel = async (item, index) => {
//        this.setState(state => {
//            const notifications = state.notifications.filter((_, j) => index !== j);
//            return { notifications };
//        });

//        let user = this.props.user;
//        user.notificationCount--;
//        this.props.setUserInfo(user);

//        await updateNotification(item.id, 3);
//    }

//    handleAccept = async (item, index) => {
//        this.setState(state => {
//            const notifications = state.notifications.filter((_, j) => index !== j);
//            return { notifications };
//        });

//        let user = this.props.user;
//        user.notificationCount--;
//        this.props.setUserInfo(user);

//        await updateNotification(item.id, 3);
//    }

//    handleAcceptInvitation = async (item, index) => {
//        const invitations = [...this.state.invitations];
//        invitations.splice(index, 1);
//        this.setState({ invitations });
//        await confirmInvitation(item.id);
//    }

//    handleDeclineInvitation = async (item, index) => {
//        const invitations = [...this.state.invitations];
//        invitations.splice(index, 1);
//        this.setState({ invitations });
//        await declineInvitation(item.id);
//    }

//    handleDismissInvitation = async (item, index) => {
//        const invitations = [...this.state.invitations];
//        invitations.splice(index, 1);
//        this.setState({ invitations });
//        await removeInvitation(item.id);
//    }

//    handleSearch = async (term) => {
//        if (term && term.length > 0) {
//            this.props.setSearchTerm(term);
//            this.handleNavIndex(0);
//        }
//    }

//    handleUpdateProfile = (b64) => {
//        this.setState({ showPhotoUploader: false });
//        let user = this.props.user;
//        user.avatar = b64;
//        this.props.setUserInfo(user);
//    }

//    handleNavIndex = (value) => {
//        this.setState({ navIndex: value });

//        switch (value) {
//            case 0:
//                this.props.setTopic("posts");
//                this.setState({ lastNavIndex: value, showChat: false, showNotifications: false, showProfileManager: false });
//                break;
//            case 1:
//                this.props.setTopic("content");
//                this.setState({ lastNavIndex: value, showChat: false, showNotifications: false, showProfileManager: false });
//                break;
//            case 2:
//                this.setState({ showChat: true, showNotifications: false, showProfileManager: false });
//                break;
//            case 3:
//                this.setState({ showChat: false, showNotifications: true, showProfileManager: false });
//                break;
//            case 4:
//                this.setState({ showChat: false, showNotifications: false, showProfileManager: true });
//                break;
//            default:
//        }

//        // ✅ if user uses nav on mobile, keep it visible briefly
//        if (this.isMobile()) this.keepBottomNavAlive(4500);
//    }

//    handleToggleChat = () => {
//        this.setState({ showChat: !this.state.showChat })
//        if (this.state.navIndex === 2) {
//            this.setState({ navIndex: this.state.lastNavIndex });
//        }
//    }

//    handleCloseProfileManager = () => {
//        this.setState({ showProfileManager: false });
//        if (this.state.navIndex === 4) {
//            this.setState({ navIndex: this.state.lastNavIndex });
//        }
//    }

//    handleCloseNotifications = () => {
//        this.setState({ showNotifications: false });
//        if (this.state.navIndex === 3) {
//            this.setState({ navIndex: this.state.lastNavIndex });
//        }
//    }

//    handleSetTopic = (topic) => {
//        if (topic === "posts") this.handleNavIndex(0);
//        if (topic === "content") this.handleNavIndex(1);
//    }

//    // ---------- renders ----------
//    chat = () => {
//        if (!this.state.showChat) return null;
//        return (
//            <ChatDrawer
//                show={this.state.showChat}
//                dark={this.props.dark}
//                setToken={this.props.setToken}
//                width={this.state.width}
//                toggleOpen={this.handleToggleChat}
//                user={this.props.user}
//                height={this.state.height}
//            />
//        );
//    }

//    welcome = () => (
//        <Welcome
//            show={this.state.showWelcome}
//            hide={() => this.setState({ showWelcome: false })}
//            handleUpdateProfile={this.handleUpdateProfile}
//            dark={this.props.dark}
//            user={this.props.user}
//            setUserInfo={this.props.setUserInfo}
//            setDark={this.props.setDark}
//            appIdentifier={this.props.appIdentifier}
//        />
//    )

//    profileManager = () => (
//        <ModalDialog
//            dark={this.state.width <= 600 ? true : this.props.dark}
//            show={this.state.showProfileManager}
//            handleClose={this.handleCloseProfileManager}
//            closeLabel="Close"
//            fullWidth={true}
//            title="Profile Manager"
//            maxWidth="xl"
//            noPad={true}
//            fullScreen={this.state.width <= 600}
//            solid={this.state.width <= 600}
//            hideScroll={true}
//            disableButtons
//            fullHeight
//        >
//            <Profile
//                {...this.props}
//                user={this.props.user}
//                setUserInfo={this.props.setUserInfo}
//                fullScreen={this.state.width <= 600}
//            />
//        </ModalDialog>
//    )

//    affiliations = () => (
//        <ModalDialog
//            dark={true}
//            show={this.state.showAffiliations}
//            handleClose={() => this.setState({ showAffiliations: false })}
//            closeLabel="Close"
//            fullWidth={true}
//            fullScreen={this.state.width <= 600}
//            solid
//            title="Affiliations"
//            maxWidth="md"
//            noPad={true}
//            hideScroll={true}
//            disableButtons
//            fullHeight
//            noBorder
//        >
//            <Affiliations
//                appIdentifier={this.props.appIdentifier}
//                dark={this.props.dark}
//                user={this.props.user}
//            />
//        </ModalDialog>
//    )

//    activities = () => (
//        <ModalDialog
//            dark={this.state.width <= 600 ? true : this.props.dark}
//            show={this.state.showActivity}
//            handleClose={() => this.setState({ showActivity: false })}
//            closeLabel="Close"
//            fullWidth={true}
//            fullScreen={this.state.width <= 600}
//            solid
//            title="My Activity and Connections"
//            maxWidth="md"
//            noPad={true}
//            hideScroll={true}
//            disableButtons
//            fullHeight
//            noBorder
//        >
//            <Activity
//                appIdentifier={this.props.appIdentifier}
//                dark={this.props.dark}
//                user={this.props.user}
//            />
//        </ModalDialog>
//    )

//    notifications = () => (
//        <Notifications
//            show={this.state.showNotifications}
//            handleClose={this.handleCloseNotifications}
//            dark={this.props.dark}
//            setUserInfo={this.props.setUserInfo}
//            user={this.props.user}
//            handleCancel={this.handleCancel}
//            handleAccept={this.handleAccept}
//            notifications={this.state.notifications}
//            setSelectedPost={this.props.setSelectedPost}
//            fullScreen={this.state.width <= 600}
//        />
//    )

//    invitations = () => (
//        <Invitations
//            show={this.state.showInvitations}
//            handleClose={() => this.setState({ showInvitations: false })}
//            dark={this.props.dark}
//            user={this.props.user}
//            handleCancel={this.handleDeclineInvitation}
//            handleAccept={this.handleAcceptInvitation}
//            handleDecline={this.handleDeclineInvitation}
//            invitations={this.state.invitations}
//        />
//    )

//    account = () => (
//        <Account
//            show={this.state.showAccount}
//            handleClose={() => this.setState({ showAccount: false })}
//            dark={this.props.dark}
//            user={this.props.user}
//            setToken={this.props.setToken}
//        />
//    )

//    // NOTE: you spelled this "bottonNav" originally; left it as-is
//    bottonNav = () => (
//        <BottomNav
//            dark={this.props.dark}
//            index={this.state.navIndex}
//            setIndex={this.handleNavIndex}
//            notificationCount={this.state.notifications.length ?? 0}
//            hasNewMessages={this.props.user.hasNewMessages}
//        />
//    )

//    // ✅ Mobile overlay: tap/press hotzone shows it; inactivity hides it
//    renderBottomNav = () => {
//        if (!this.isMobile()) return this.bottonNav(false);

//        const visible = this.state.showBottomNavMobile;

//        return (
//            <>
//                {/* HOTZONE: tap/press near bottom to reveal */}
//                <div
//                    style={{
//                        position: "fixed",
//                        left: 0,
//                        right: 0,
//                        bottom: 0,
//                        height: 70,               // bigger target = easier to trigger
//                        zIndex: 999998,
//                        background: "transparent",
//                        touchAction: "manipulation",
//                    }}
//                    onPointerDown={() => this.showBottomNav()}
//                    onPointerUp={() => this.scheduleBottomNavHide(4500)}
//                    onPointerCancel={() => this.scheduleBottomNavHide(4500)}
//                    onTouchStart={() => this.showBottomNav()}          // extra reliability for iOS
//                    onTouchEnd={() => this.scheduleBottomNavHide(4500)}
//                />

//                {/* SLIDE-UP OVERLAY */}
//                <div
//                    style={{
//                        position: "fixed",
//                        left: 0,
//                        right: 0,
//                        bottom: 0,
//                        zIndex: 999999,
//                        transform: visible ? "translateY(0)" : "translateY(110%)",
//                        transition: "transform 220ms ease",
//                        pointerEvents: visible ? "auto" : "none",
//                    }}
//                    // any interaction with nav keeps it alive
//                    onPointerDown={() => this.keepBottomNavAlive(4500)}
//                    onPointerMove={() => this.keepBottomNavAlive(4500)}
//                    onTouchStart={() => this.keepBottomNavAlive(4500)}
//                    onMouseEnter={() => this.keepBottomNavAlive(4500)}
//                    // when they release / stop interacting, start the hide timer
//                    onPointerUp={() => this.scheduleBottomNavHide(4500)}
//                    onTouchEnd={() => this.scheduleBottomNavHide(4500)}
//                >
//                    {this.bottonNav(true)}
//                </div>
//            </>
//        );
//    };

//    content = () => {
//        return (
//            <>
//                <TopAppBar
//                    user={this.props.user}
//                    setToken={this.props.setToken}
//                    dark={this.props.dark}
//                    setDark={this.props.setDark}
//                    getPhoto={this.props.getPhoto}
//                    setUserInfo={this.props.setUserInfo}
//                    searchCallback={this.handleSearch}
//                    handleProfileOpen={() => this.setState({ showProfileManager: !this.state.showProfileManager })}
//                    handleAffiliationsOpen={() => this.setState({ showAffiliations: !this.state.showAffiliations })}
//                    handleActivityOpen={() => this.setState({ showActivity: !this.state.showActivity })}
//                    handleNotificationsOpen={() => this.setState({ showNotifications: !this.state.showNotifications })}
//                    handleInvitationsOpen={() => this.setState({ showInvitations: !this.state.showInvitations })}
//                    handleAccountOpen={() => this.setState({ showAccount: !this.state.showAccount })}
//                    handleChatOpen={() => this.setState({ showChat: !this.state.showChat })}
//                    notificationCount={this.state.notifications.length ?? 0}
//                    invitationCount={this.state.invitations.length ?? 0}
//                    searchTerm={this.props.searchTerm ?? ""}
//                    authenticated={this.props.authenticated}
//                    newRegistration={this.props.newRegistration}
//                    setNewRegistration={this.props.setNewRegistration}
//                    setAuthenticated={this.props.setAuthenticated}
//                    setTopic={this.handleSetTopic}
//                    navIndex={this.state.navIndex}
//                    appOptions={this.props.appOptions}
//                />

//                {this.props.children}

//                {/* ✅ Bottom nav behavior you described */}
//                {this.renderBottomNav()}

//                {this.state.showWelcome && this.welcome()}
//                {this.state.showChat && this.chat()}
//                {this.state.showProfileManager && this.profileManager()}
//                {this.state.showAffiliations && this.affiliations()}
//                {this.state.showActivity && this.activities()}
//                {this.state.showNotifications && this.notifications()}
//                {this.state.showInvitations && this.invitations()}
//                {this.state.showAccount && this.account()}
//            </>
//        );
//    }

//    render() {
//        return this.content();
//    }
//}


//import React, { Component } from 'react';

////Custom Components
//import TopAppBar from '../../../components/SiteSpecific/TopAppBar';
//import { Profile } from '../Profile/Profile';
//import { ModalDialog } from '../Utilities/ModalDialog'
//import { BottomNav } from '../Utilities/BottomNav';
//import { Welcome } from '../../../components/SiteSpecific/Welcome';
//import { Affiliations } from '../Groups/Affiliations'
//import { Activity } from '../Groups/Activity'
//import { ChatDrawer } from '../Messenger/ChatDrawer';
//import { Notifications } from '../Notifications/Notifications'
//import { Invitations } from '../Invitations/Invitations'
//import { Account } from '../Account/Account'

////Database Services
//import { getNotifications, updateNotification } from '../../DataServices/NotificationService'
//import { getInvitations, confirmInvitation, declineInvitation, removeInvitation } from '../../DataServices/OrganizationService'

//export class Layout extends Component {

//    constructor(props) {
//        super(props);
//        this.state = {
//            showMenu: false,
//            showPhotoUploader: false,
//            showSearchResults: false,
//            showProfileManager: false,
//            showAffiliations: false,
//            showNotifications: false,
//            showInvitations: false,
//            showAccount: false,
//            showChat: false,
//            notifications: [],
//            invitations: [],
//            fetchNewPostsInterval: 30000,
//            autoFetchNew: true,
//            navIndex: 0,
//            lastNavIndex: 0,
//            width: 0,
//            height: 0,
//            showBottomNavMobile: false,
//            // ---- Added for mobile bottom-nav hide/show overlay ----
//            showBottomNavOverlay: false,
//        };

//        // ---- Added: internal timers for overlay auto-hide ----

//        this._bottomNavHideTimer = null;
//        this._boundOnMouseMove = null;
//        this._boundOnTouchStart = null;
//    }
//    isMobile = () => this.state.width <= 600;

//    showBottomNavTemporarily = () => {
//        if (!this.isMobile()) return;

//        if (this._bottomNavHideTimer) clearTimeout(this._bottomNavHideTimer);

//        if (!this.state.showBottomNavMobile) {
//            this.setState({ showBottomNavMobile: true });
//        }

//        // auto-hide after inactivity
//        this._bottomNavHideTimer = setTimeout(() => {
//            this.setState({ showBottomNavMobile: false });
//        }, 1800);
//    };

//    hideBottomNavSoon = () => {
//        if (!this.isMobile()) return;
//        if (this._bottomNavHideTimer) clearTimeout(this._bottomNavHideTimer);

//        this._bottomNavHideTimer = setTimeout(() => {
//            this.setState({ showBottomNavMobile: false });
//        }, 600);
//    };

//    handleMobileEdgeDetection = (clientY) => {
//        if (!this.isMobile()) return;

//        const h = this.state.height || window.innerHeight;
//        const HOTZONE = 40; // px from bottom

//        // near bottom -> show
//        if (clientY >= h - HOTZONE) {
//            this.showBottomNavTemporarily();
//        } else {
//            // away from bottom -> hide soon
//            this.hideBottomNavSoon();
//        }
//    };

//    componentDidMount() {
//        if (this.props.user && this.props.user.accessToken && !this.props.user.hideWelcome) {
//            this.setState({ showWelcome: true });
//        }
//        this.getInvitations();
//        this.getNotifications();
//        //wait 1 minute then set auto-fetcher for new posts
//        if (this.state.autoFetchNew) {
//            setTimeout(
//                this.interval = setInterval(() => {
//                    this.getNewInvitations();
//                    this.getNewNotifications();
//                }, this.state.fetchNewPostsInterval),
//                60000);
//        }
//        this.updateWindowDimensions();
//        window.addEventListener('resize', this.updateWindowDimensions);

//        // ---- Added: listeners to reveal bottom nav when user is near bottom (mouse) or taps near bottom (touch) ----
//        //window.addEventListener('mousemove', this.handleGlobalPointerForBottomNav, { passive: true });
//        //window.addEventListener('touchstart', this.handleGlobalTouchForBottomNav, { passive: true });

//        this._boundOnMouseMove = (e) => this.handleMobileEdgeDetection(e.clientY);
//        this._boundOnTouchStart = (e) => {
//            if (!e.touches || !e.touches.length) return;
//            this.handleMobileEdgeDetection(e.touches[0].clientY);
//        };

//        window.addEventListener("mousemove", this._boundOnMouseMove, { passive: true });
//        window.addEventListener("touchstart", this._boundOnTouchStart, { passive: true });

//    }
//    componentWillUnmount() {
//        //clear autofetch interval if it exists
//        if (this.interval)
//            clearInterval(this.interval);

//        window.removeEventListener('resize', this.updateWindowDimensions);

//        // ---- Added: cleanup listeners/timers ----
//        window.removeEventListener('mousemove', this.handleGlobalPointerForBottomNav);
//        window.removeEventListener('touchstart', this.handleGlobalTouchForBottomNav);
//        if (this._bottomNavHideTimer) clearTimeout(this._bottomNavHideTimer);

//        if (this._boundOnMouseMove) {
//            window.removeEventListener("mousemove", this._boundOnMouseMove);
//        }
//        if (this._boundOnTouchStart) {
//            window.removeEventListener("touchstart", this._boundOnTouchStart);
//        }

//    }
//    updateWindowDimensions = () => {
//        this.setState({ width: window.innerWidth, height: window.innerHeight });
//    }

//    // ------------------------------
//    // Added: bottom nav overlay show/hide behavior (mobile only)
//    // ------------------------------
//    isMobile = () => {
//        // keep it aligned with your existing 600px checks
//        return (this.state.width || window.innerWidth) <= 600;
//    }

//    showBottomNavTemporarily = (ms = 2500) => {
//        if (!this.isMobile()) return;

//        if (this._bottomNavHideTimer) clearTimeout(this._bottomNavHideTimer);

//        if (!this.state.showBottomNavOverlay) {
//            this.setState({ showBottomNavOverlay: true });
//        }

//        this._bottomNavHideTimer = setTimeout(() => {
//            this.setState({ showBottomNavOverlay: false });
//        }, ms);
//    }

//    handleGlobalPointerForBottomNav = (e) => {
//        if (!this.isMobile()) return;
//        const y = e?.clientY ?? 0;
//        const h = window.innerHeight || this.state.height || 0;
//        // "hover near bottom"
//        if (h && y > (h - 32)) {
//            this.showBottomNavTemporarily(2500);
//        }
//    }

//    handleGlobalTouchForBottomNav = (e) => {
//        if (!this.isMobile()) return;
//        const touch = e?.touches?.[0];
//        if (!touch) return;
//        const y = touch.clientY ?? 0;
//        const h = window.innerHeight || this.state.height || 0;
//        // "tap near bottom"
//        if (h && y > (h - 60)) {
//            this.showBottomNavTemporarily(3000);
//        }
//    }

//    // Existing code below (unchanged except where noted)
//    getNotifications = async () => {

//        const data = await getNotifications(true, this.props.appIdentifier);
//        const notifications = [];
//        if (data) {
//            for (var i = 0; i < data.length; i++) {
//                if (data[i].referencedUser) {
//                    notifications.push(data[i]);
//                }
//            }
//            this.setState({
//                notifications: notifications,
//                loading: false
//            });
//        }

//    }
//    getNewNotifications = async () => {

//        const data = await getNotifications(true, this.props.appIdentifier);
//        const notifications = [];
//        if (data) {

//            for (var i = 0; i < data.length; i++) {
//                if (data[i].referencedUser) {
//                    notifications.push(data[i]);
//                }
//            }
//            if (notifications.length === this.state.notifications.length) {
//                if (notifications.length === 0) {
//                    return;
//                }
//                else {
//                    if (notifications[0].id === this.state.notifications[0].id && notifications[notifications.length - 1].id === this.state.notifications[this.state.notifications.length - 1].id) {
//                        return;
//                    }
//                }
//            }
//            else {
//                this.setState({
//                    notifications: notifications,
//                    loading: false
//                });
//            }
//        }

//    }
//    getInvitations = async () => {

//        const data = await getInvitations();
//        const invitations = [];
//        if (data) {
//            for (var i = 0; i < data.length; i++) {
//                if (data[i].fromUser) {
//                    invitations.push(data[i]);
//                }
//            }
//            this.setState({ invitations });;
//        }

//    }
//    getNewInvitations = async () => {

//        const data = await getInvitations();
//        const invitations = [];
//        if (data) {

//            for (var i = 0; i < data.length; i++) {
//                if (data[i].fromUser) {
//                    invitations.push(data[i]);
//                }
//            }
//            if (invitations.length === this.state.invitations.length) {
//                if (invitations.length === 0) {
//                    return;
//                }
//                else {
//                    if (invitations[0].id === this.state.invitations[0].id && invitations[invitations.length - 1].id === this.state.invitations[this.state.invitations.length - 1].id) {
//                        return;
//                    }
//                }
//            }
//            else {
//                this.setState({ invitations });
//            }
//        }

//    }
//    handleCancel = async (item, index) => {

//        this.setState(state => {
//            const notifications = state.notifications.filter((item, j) => index !== j);
//            return { notifications, };
//        });

//        let user = this.props.user;
//        user.notificationCount--;
//        this.props.setUserInfo(user);

//        await updateNotification(item.id, 3);

//    }
//    handleAccept = async (item, index) => {

//        this.setState(state => {
//            const notifications = state.notifications.filter((item, j) => index !== j);
//            return { notifications, };
//        });

//        let user = this.props.user;
//        user.notificationCount--;
//        this.props.setUserInfo(user);
//        await updateNotification(item.id, 3);

//    }
//    handleAcceptInvitation = async (item, index) => {
//        const invitations = [...this.state.invitations];
//        invitations.splice(index, 1);
//        this.setState({ invitations });
//        await confirmInvitation(item.id);
//    }
//    handleDeclineInvitation = async (item, index) => {
//        const invitations = [...this.state.invitations];
//        invitations.splice(index, 1);
//        this.setState({ invitations });
//        await declineInvitation(item.id);
//    }
//    handleDismissInvitation = async (item, index) => {
//        const invitations = [...this.state.invitations];
//        invitations.splice(index, 1);
//        this.setState({ invitations });
//        await removeInvitation(item.id);
//    }
//    handleSearch = async (term) => {
//        if (term && term.length > 0) {
//            this.props.setSearchTerm(term);
//            this.handleNavIndex(0);
//        }
//    }
//    handleUpdateProfile = (b64) => {
//        this.setState({ showPhotoUploader: false });
//        let user = this.props.user;
//        user.avatar = b64;
//        this.props.setUserInfo(user);
//    }
//    handleUpdatePrivacy = (privacy) => {

//    }
//    handleNavIndex = (value) => {
//        this.setState({ navIndex: value });
//        switch (value) {
//            case 0:
//                this.props.setTopic("posts");
//                this.setState({ lastNavIndex: value, showChat: false, showNotifications: false, showProfileManager: false });
//                break;
//            case 1:
//                this.props.setTopic("content");
//                this.setState({ lastNavIndex: value, showChat: false, showNotifications: false, showProfileManager: false });
//                break;
//            case 2:
//                this.setState({ showChat: true, showNotifications: false, showProfileManager: false });

//                break;
//            case 3:
//                this.setState({ showChat: false, showNotifications: true, showProfileManager: false });
//                break;
//            case 4:
//                this.setState({ showChat: false, showNotifications: false, showProfileManager: true });
//                break;

//            default:
//        }

//        // ---- Added: if user interacts with nav on mobile, briefly show bottom nav so it doesn't feel "gone" ----
//        if (this.isMobile()) {
//            this.showBottomNavTemporarily(1800);
//        }
//    }
//    handleToggleChat = () => {
//        this.setState({ showChat: !this.state.showChat })
//        if (this.state.navIndex === 2) {
//            this.setState({ navIndex: this.state.lastNavIndex });
//        }
//    }
//    handleCloseProfileManager = () => {
//        this.setState({ showProfileManager: false });
//        if (this.state.navIndex === 4) {
//            this.setState({ navIndex: this.state.lastNavIndex });
//        }
//    }
//    handleCloseNotifications = () => {
//        this.setState({ showNotifications: false });
//        if (this.state.navIndex === 3) {
//            this.setState({ navIndex: this.state.lastNavIndex });
//        }
//    }
//    handleSetTopic = (topic) => {
//        if (topic === "posts") {
//            this.handleNavIndex(0);
//        }
//        if (topic === "content") {
//            this.handleNavIndex(1);
//        }
//    }

//    //Render Funcs
//    chat = () => {
//        if (this.state.showChat) {
//            return (
//                <ChatDrawer
//                    show={this.state.showChat}
//                    dark={this.props.dark}
//                    setToken={this.props.setToken}
//                    width={this.state.width}
//                    toggleOpen={this.handleToggleChat}
//                    user={this.props.user}
//                    height={this.state.height}
//                />
//            )
//        }
//        return null;
//    }
//    welcome = () => {
//        return (
//            <Welcome
//                show={this.state.showWelcome}
//                hide={() => this.setState({ showWelcome: false })}
//                handleUpdateProfile={this.handleUpdateProfile}
//                dark={this.props.dark}
//                user={this.props.user}
//                setUserInfo={this.props.setUserInfo}
//                setDark={this.props.setDark}
//                appIdentifier={this.props.appIdentifier}
//            />
//        )
//    }
//    profileManager = () => {
//        return (
//            <ModalDialog
//                dark={this.state.width <= 600 ? true : this.props.dark}
//                show={this.state.showProfileManager}
//                handleClose={this.handleCloseProfileManager}
//                closeLabel="Close"
//                fullWidth={true}
//                title="Profile Manager"
//                maxWidth="xl"
//                noPad={true}
//                fullScreen={this.state.width <= 600}
//                solid={this.state.width <= 600}
//                hideScroll={true}
//                disableButtons
//                fullHeight
//            >
//                <Profile
//                    {...this.props}
//                    user={this.props.user}
//                    setUserInfo={this.props.setUserInfo}
//                    fullScreen={this.state.width <= 600}
//                />
//            </ModalDialog>
//        )
//    }
//    affiliations = () => {
//        return (
//            <ModalDialog
//                dark={true}
//                show={this.state.showAffiliations}
//                handleClose={() => this.setState({ showAffiliations: false })}
//                closeLabel="Close"
//                fullWidth={true}
//                fullScreen={this.state.width <= 600}
//                solid
//                title="Affiliations"
//                maxWidth="md"
//                noPad={true}
//                hideScroll={true}
//                disableButtons
//                fullHeight
//                noBorder
//            >
//                <Affiliations
//                    appIdentifier={this.props.appIdentifier}
//                    dark={this.props.dark}
//                    user={this.props.user}
//                />
//            </ModalDialog>
//        )
//    }
//    activities = () => {
//        return (
//            <ModalDialog
//                dark={this.state.width <= 600 ? true : this.props.dark}
//                show={this.state.showActivity}
//                handleClose={() => this.setState({ showActivity: false })}
//                closeLabel="Close"
//                fullWidth={true}
//                fullScreen={this.state.width <= 600}
//                solid
//                title="My Activity and Connections"
//                maxWidth="md"
//                noPad={true}
//                hideScroll={true}
//                disableButtons
//                fullHeight
//                noBorder
//            >
//                <Activity
//                    appIdentifier={this.props.appIdentifier}
//                    dark={this.props.dark}
//                    user={this.props.user}
//                />
//            </ModalDialog>
//        )
//    }
//    notifications = () => {
//        return (
//            <Notifications
//                show={this.state.showNotifications}
//                handleClose={this.handleCloseNotifications}
//                dark={this.props.dark}
//                setUserInfo={this.props.setUserInfo}
//                user={this.props.user}
//                handleCancel={this.handleCancel}
//                handleAccept={this.handleAccept}
//                notifications={this.state.notifications}
//                setSelectedPost={this.props.setSelectedPost}
//                fullScreen={this.state.width <= 600}
//            />
//        )
//    }
//    invitations = () => {
//        return (
//            <Invitations
//                show={this.state.showInvitations}
//                handleClose={() => this.setState({ showInvitations: false })}
//                dark={this.props.dark}
//                user={this.props.user}
//                handleCancel={this.handleDeclineInvitation}
//                handleAccept={this.handleAcceptInvitation}
//                handleDecline={this.handleDeclineInvitation}
//                invitations={this.state.invitations}
//            />
//        )
//    }
//    account = () => {
//        return (
//            <Account
//                show={this.state.showAccount}
//                handleClose={() => this.setState({ showAccount: false })}
//                dark={this.props.dark}
//                user={this.props.user}
//                setToken={this.props.setToken}
//            />
//        )
//    }

//    // NOTE: you spelled this "bottonNav" originally; left it as-is
//    bottonNav = () => {
//        return (
//            <BottomNav
//                dark={this.props.dark}
//                index={this.state.navIndex}
//                setIndex={this.handleNavIndex}
//                notificationCount={this.state.notifications.length ?? 0}
//                hasNewMessages={this.props.user.hasNewMessages}
//            />
//        )
//    }
//    renderBottomNav = () => {
//        // desktop: no change
//        if (!this.isMobile()) return this.bottonNav(false);

//        const visible = this.state.showBottomNavMobile;

//        // ✅ IMPORTANT: we conditionally render on mobile to guarantee it hides
//        // (this avoids issues when BottomNav itself uses position: fixed)
//        return (
//            <>
//                {/* Bottom hotzone to trigger reveal (in case no mousemove fires on some mobile browsers) */}
//                <div
//                    style={{
//                        position: "fixed",
//                        left: 0,
//                        right: 0,
//                        bottom: 0,
//                        height: 48,
//                        zIndex: 99998,
//                        background: "transparent",
//                    }}
//                    onMouseEnter={this.showBottomNavTemporarily}
//                    onTouchStart={this.showBottomNavTemporarily}
//                />

//                {visible && (
//                    <div
//                        style={{
//                            position: "fixed",
//                            left: 0,
//                            right: 0,
//                            bottom: 0,
//                            zIndex: 99999,
//                        }}
//                        onMouseLeave={this.hideBottomNavSoon}
//                        onTouchStart={this.showBottomNavTemporarily}
//                    >
//                        {this.bottonNav(true)}
//                    </div>
//                )}
//            </>
//        );
//    };

//    // ---- Added: wrapper that hides bottom nav on mobile, slides it up when revealed ----
//    bottomNavOverlayWrapper = () => {
//        const isMobile = this.isMobile();

//        // Desktop: behave exactly as before (always visible)
//        if (!isMobile) {
//            return this.bottonNav();
//        }

//        const visible = this.state.showBottomNavOverlay;

//        // Slide-up overlay container
//        return (
//            <div
//                style={{
//                    position: "fixed",
//                    left: 0,
//                    right: 0,
//                    bottom: 0,
//                    zIndex: 1000000,
//                    transform: visible ? "translateY(0)" : "translateY(110%)",
//                    transition: "transform 220ms ease",
//                    pointerEvents: visible ? "auto" : "none",
//                }}
//                onMouseEnter={() => this.showBottomNavTemporarily(3000)}
//                onTouchStart={() => this.showBottomNavTemporarily(3500)}
//            >
//                {this.bottonNav(true)}
//            </div>
//        );
//    }

//    content = () => {
//        return (
//            <>
//                <TopAppBar
//                    user={this.props.user}
//                    setToken={this.props.setToken}
//                    dark={this.props.dark}
//                    setDark={this.props.setDark}
//                    getPhoto={this.props.getPhoto}
//                    setUserInfo={this.props.setUserInfo}
//                    searchCallback={this.handleSearch}
//                    handleProfileOpen={() => this.setState({ showProfileManager: !this.state.showProfileManager })}
//                    handleAffiliationsOpen={() => this.setState({ showAffiliations: !this.state.showAffiliations })}
//                    handleActivityOpen={() => this.setState({ showActivity: !this.state.showActivity })}
//                    handleNotificationsOpen={() => this.setState({ showNotifications: !this.state.showNotifications })}
//                    handleInvitationsOpen={() => this.setState({ showInvitations: !this.state.showInvitations })}
//                    handleAccountOpen={() => this.setState({ showAccount: !this.state.showAccount })}
//                    handleChatOpen={() => this.setState({ showChat: !this.state.showChat })}
//                    notificationCount={this.state.notifications.length ?? 0}
//                    invitationCount={this.state.invitations.length ?? 0}
//                    searchTerm={this.props.searchTerm ?? ""}
//                    //IW props
//                    authenticated={this.props.authenticated}
//                    newRegistration={this.props.newRegistration}
//                    setNewRegistration={this.props.setNewRegistration}
//                    setAuthenticated={this.props.setAuthenticated}
//                    setTopic={this.handleSetTopic}
//                    navIndex={this.state.navIndex}
//                    appOptions={this.props.appOptions}
//                />

//                {this.props.children}

//                {/* CHANGED: wrap BottomNav so it hides/slides on mobile; desktop unchanged */}
//                {this.renderBottomNav()}


//                {this.state.showWelcome && this.welcome()}
//                {this.state.showChat && this.chat()}
//                {this.state.showProfileManager && this.profileManager()}
//                {this.state.showAffiliations && this.affiliations()}
//                {this.state.showActivity && this.activities()}
//                {this.state.showNotifications && this.notifications()}
//                {this.state.showInvitations && this.invitations()}
//                {this.state.showAccount && this.account()}
//            </>
//        );
//    }

//    //main component render
//    render() {
//        return this.content();
//    }
//}



